import { Box } from '@material-ui/core';
import { SText } from '@setvi/shared/components';
import { TextColor } from '@setvi/shared/enums';
import { Product } from '@setvi/shared/interfaces';
import { Stock } from 'pages/products/components/stock';
import { Customer } from 'Services/MongoRealm/Types';

interface StockContentProps {
  product: Product;
  selectedCustomer: Customer;
  stockRefresh?: boolean;
  updateProduct?: (product: Product, newValues: Partial<Product>) => void;
  onClick?: (product: Product) => void;
}

export const StockContent = ({
  product,
  selectedCustomer,
  stockRefresh,
  updateProduct,
  onClick
}: StockContentProps) => (
  <Box>
    <Stock
      inventory={product.inventory}
      isDropship={product.dropship}
      selectedCustomer={selectedCustomer}
      stockInfo={product?.stockInfo}
      isStockProduct={product?.isStockProduct}
      {...(stockRefresh
        ? {
            stockRefresh: {
              id: product.sku,
              onStockRefresh: newInventory =>
                updateProduct(product, { inventory: newInventory })
            }
          }
        : { onClick: () => onClick?.(product) })}
    />

    {!!product?.custom?.leadTime && (
      <SText
        // @ts-ignore
        title={`Lead time: ${product?.custom?.leadTime?.value || product?.custom?.leadTime} Days`}
        size="sm"
        lineHeight="20px"
        fontColor={TextColor.Grey}
      />
    )}
  </Box>
);
